import { Modal } from '@web/components/atoms/Modal'
import useActionDialogStore from './useActionDialogStore'
import { Title } from '@web/components/atoms/Typography'
import { HStack, VStack } from '@web/components/atoms/Layout'
import { Button } from '@web/components/atoms/Button'
import { useState } from 'react'

const ActionDialog = () => {
  const {
    title,
    content,
    ctaText,
    callback,
    actions,
    type,
    withCancelButton = true,
  } = useActionDialogStore((state) => state)
  const [isLoading, setIsLoading] = useState(false)
  const isManual = type === 'manual'

  const isOpen = Boolean(callback)
  return isOpen ? (
    <Modal
      id="action-dialog"
      modalContentProps={{ minW: '666px' }}
      headerSlot={
        typeof title === 'string' ? (
          <Title textAlign="center" fontSize="20px" fontWeight={600} mt="8px">
            {title}
          </Title>
        ) : (
          title
        )
      }
      isOpen={true}
      withCloseButton={true}
      onClose={() => actions.clearDialog()}
      contentSlot={
        <form
          onSubmit={
            isManual
              ? (e) => {
                  e.preventDefault()
                }
              : async (e) => {
                  e.preventDefault()
                  setIsLoading(true)
                  try {
                    const shouldFail = await callback!(true, e)

                    if (shouldFail) {
                      return
                    }

                    actions.clearDialog()
                  } finally {
                    setIsLoading(false)
                  }
                }
          }
        >
          <VStack w="100%" px="32px">
            {content}
            {/* manual action dialogs handle their own state */}
            {!isManual && (
              <HStack w="100%" justifyContent={withCancelButton ? 'space-between' : 'center'} mt="32px">
                {withCancelButton && (
                  <Button id="cancel" buttonAppearance="secondary" onClick={() => actions.clearDialog()}>
                    Cancel
                  </Button>
                )}
                <Button
                  id="save-continue"
                  type="submit"
                  loading={isLoading}
                  {...(type === 'danger'
                    ? { colorPalette: 'red', buttonAppearance: 'unstyled' }
                    : { buttonAppearance: 'primary' })}
                >
                  {ctaText}
                </Button>
              </HStack>
            )}
          </VStack>
        </form>
      }
    />
  ) : null
}

export default ActionDialog
